<template>
    <div>
        <b-row>
            <b-col class="mb-3" sm="10">
                <b-button-toolbar>
                    <b-button-group>
                        <b-button :disabled="!selected.length" @click="print()" variant="outline-secondary" size="sm">
                            <b-icon-printer></b-icon-printer>
                            <span class="ml-2 mr-1">Print</span>
                        </b-button>
                        <b-button v-if="selected.length < rowCount" @click="selectAll()" variant="outline-secondary" size="sm">
                            <b-icon-list-check></b-icon-list-check>
                            <span class="ml-2 mr-1">Select All</span>
                        </b-button>
                        <b-button v-else-if="selected.length > 0" @click="clearSelected()" variant="outline-secondary" size="sm">
                            <b-icon-list></b-icon-list>
                            <span class="ml-2 mr-1">Clear Selected</span>
                        </b-button>
                        <b-button v-if="rowCount > 0" :pressed.sync='selectRange' @click="setSelectRange()" variant='outline-secondary' size="sm">
                            <b-icon-check v-if="selectRange"></b-icon-check> 
                            <b-icon-list v-else></b-icon-list>
                            <span class="ml-2 mr-1">Select Range</span>
                        </b-button>

                        <b-button @click="addItem()" variant="outline-secondary" size="sm" :disabled='busy'>
                            <b-icon-plus></b-icon-plus>
                            <span class="ml-2 mr-1">New Item</span>
                        </b-button>

                        <b-button @click="createTemplate()" variant="outline-secondary" size="sm" :disabled="selected.length !== 1">
                            <b-icon-file-earmark></b-icon-file-earmark>
                            <span class="ml-2 mr-1">Template</span>
                        </b-button>

                    <b-dropdown variant="outline-secondary" size="sm">
                        <template #button-content>
                            <b-icon-gear></b-icon-gear>
                            <span class="ml-2 mr-1">Settings</span>
                        </template>
                        <b-dropdown-form style="width: 15rem;">
                            <b-form-checkbox size="sm" switch v-model="settings.showTagButtons">Show Tag Buttons</b-form-checkbox>
                        </b-dropdown-form>
                    </b-dropdown>

                    <b-dropdown variant="outline-secondary" size="sm">
                        <template #button-content>
                            <b-icon-sliders></b-icon-sliders>
                            <span class="ml-2 mr-1">Defaults</span>
                        </template>
                        <b-dropdown-form style="width: 15rem;">
                            <b-input-group size="sm">
                                <b-input disabled value="Location"></b-input>
                                <b-input v-model="defaults.location"></b-input>
                            </b-input-group>

                            <b-input-group size="sm" class="mt-3">
                                <b-input disabled value="Source"></b-input>
                                <b-input v-model="defaults.source"></b-input>
                            </b-input-group>

                            <b-input-group size="sm" class="mt-3">
                                <b-input disabled value="Hype"></b-input>
                                <b-input v-model="defaults.hype"></b-input>
                            </b-input-group>

                            <b-input-group size="sm" class="mt-3">
                                <b-checkbox v-model="defaults.offsite" switch>Off-site</b-checkbox>
                            </b-input-group>
                            <b-input-group size="sm" class="mt-3 flex-column flex-nowrap">
                                Research Sites
                                <b-checkbox v-for="site in searchSitesArray" :key="site" v-model="defaults.researchSites" :value="site" class="pr-4" :disabled="researchSiteDisabled(site)">{{site}}</b-checkbox>
                            </b-input-group>
                        </b-dropdown-form>
                    </b-dropdown>

                        <b-button v-b-modal.uploadModal variant="outline-secondary" size="sm">
                            <b-icon-cloud-upload></b-icon-cloud-upload>
                            <span class="ml-2 mr-1">Upload</span>
                        </b-button>

                        <b-button @click="openDiscogsMatching" variant="outline-secondary" size="sm">
                            <b-icon-arrow-left-right></b-icon-arrow-left-right>
                            <span class="ml-2 mr-1">Discogs</span>
                        </b-button>

                        <b-button @click="openBulkEdit" variant="outline-secondary" size="sm" :disabled="!selected.length">
                            <b-icon-pencil-square></b-icon-pencil-square>
                            <span class="ml-2 mr-1">Bulk Edit</span>
                        </b-button>
                    </b-button-group>
                </b-button-toolbar>
            </b-col>

            <b-col class="py-2" align="right">
                {{ countText }}
            </b-col>
        </b-row>

        <b-modal id="uploadModal"
                 size="md"
                 scrollable
                 hide-footer
                 button-size="sm"
                 centered>

            <template #modal-header>
                <h4>Upload</h4>
            </template>

            <uploader></uploader>
        </b-modal>

        <b-modal id="discogsMatchingModal"
                 size="xl"
                 scrollable
                 button-size="sm"
                 centered>

            <template #modal-header>
                <h4>Discogs Matching</h4>
            </template>

            <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="$bvModal.hide('discogsMatchingModal')" variant="success">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Done</span>
                </b-button>
            </template>

            <discogs-matching></discogs-matching>
        </b-modal>

        <b-modal id="bulkEditModal"
                 size="md"
                 scrollable
                 button-size="sm"
                 centered>

            <template #modal-header>
                <h4>Bulk Edit ({{ selected.length }} items)</h4>
            </template>

            <template #modal-footer="{  }">
                <b-button size="sm" class="mb-0" @click="doBulkEdit" variant="success" :disabled="bulkEditSelected.length === 0  && bulkSuppress.length === 0 && bulkUnsuppress.length === 0">
                    <b-icon-check-square-fill></b-icon-check-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Bulk Edit</span>
                </b-button>

                <b-button size="sm" class="mb-0" @click="cancelBulkEdit" variant="secondary">
                    <b-icon-x-square-fill></b-icon-x-square-fill>
                    <span class="p-xl-2 pl-2 pr-1">Discard</span>
                </b-button>
            </template>

            <bulk-edit :items="selected" :defaults="defaults" @bulkEditSelected="updateBulkEditSelected"></bulk-edit>
            <div class="mt-3">
                Suppress
                <div class="d-flex">
                    <b-checkbox v-for="site in suppressSiteList" :key="site" v-model="bulkSuppress" :value="site" :disabled="isSuppressedDisabled(site)" class="pr-4">{{site}}</b-checkbox>
                </div>
                <b-input v-model="suppressionReason"
                    size="sm"
                    class="mt-2"
                    :state="suppressionReason && suppressionReason ? null : false"
                    placeholder="Suppression reason"></b-input>
            </div>
            <div class="mt-3">
               Unsuppress
               <div class="d-flex">
                    <b-checkbox v-for="site in suppressSiteList" :key="site" v-model="bulkUnsuppress" :value="site"  :disabled="isUnsuppressedDisabled(site)" class="pr-4">{{site}}</b-checkbox>
                </div>
            </div>
            

            <div v-if="isBulkEditing && bulkEditItems.length > 0" class="mt-3">
                <h6>Editing Items</h6>
                <b-list-group class="mt-3">
                    <b-list-group-item v-for="(bulkItem, index) in bulkEditItems" :key="index">
                        <b-row>
                            <b-col>
                                <span>Item {{ bulkItem.itemId }}</span>
                            </b-col>

                            <b-col align="right">
                                <b-spinner v-if="bulkItem.status === 'busy'" small></b-spinner>
                                <div v-else-if="bulkItem.status === 'error'">
                                    <small class="mr-2">{{ bulkItem.msg }}</small>
                                    <b-icon-exclamation-circle-fill variant="danger"></b-icon-exclamation-circle-fill>
                                </div>

                                <div v-else-if="bulkItem.status === 'success'">
                                    <b-icon-check-circle-fill variant="success"></b-icon-check-circle-fill>
                                </div>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </b-modal>
    </div>

</template>

<script>
    import Uploader from "./Uploader";
    import BulkEdit from "./BulkEdit";
    import DiscogsMatching from "./DiscogsMatching";
    import inventoryApi from "../../api/inventory";
    import suppressSiteList from "../../assets/suppressSiteList";
    import searchSitesList from "../../assets/searchSitesList";

    export default {
        name: "Item",
        props: [ 'selected', 'rowCount', 'selectRange', 'busy' ],
        mixins: [ inventoryApi, suppressSiteList, searchSitesList ],

        components: { Uploader, BulkEdit, DiscogsMatching },
        data() {
            return {
                settings: {
                    showTagButtons: false
                },
                defaults: {
                    location: null,
                    source: null,
                    hype: '',
                    offsite: false,
                    researchSites: [],
                },
                bulkEditItems: [],
                bulkEditSelected: [],
                bulkSuppress: [],
                bulkUnsuppress: [],
                isBulkEditing: false,
                suppressionReason: null,
            }
        },
        created() {
            this.defaults.researchSites = this.searchSitesArray;
            this.fetchDefaults();
        },
        methods: {
            setSelectRange() {
                this.$emit('setSelectRange')
            },
            openBulkEdit() {
                this.bulkEditItems = [];
                this.$bvModal.show('bulkEditModal');
            },
            isUnsuppressedDisabled(value) {
                return this.bulkSuppress.includes(value);
            },
            isSuppressedDisabled(value) {
                return this.bulkUnsuppress.includes(value);
            },
            openDiscogsMatching() {
                this.$bvModal.show('discogsMatchingModal');
            },
            updateBulkEditSelected(selected) {
                this.bulkEditSelected = selected;
            },
            async doBulkEdit() {
                this.bulkEditItems = [];

                this.isBulkEditing = true;

                for (let k = 0; k < this.selected.length; k++) {
                    this.bulkEditItems.push({ itemId: this.selected[k].itemId, status: 'busy' });
                    
                    try {
                        const item = await this.getItem(this.selected[k].itemId);
                        const listingIndex = this.findListingIndex(item, this.selected[k].listing._id);
                        let suppressedArray = [...item.suppressed];

                        if (this.bulkSuppress.length > 0) {
                                this.bulkSuppress.forEach((site)=> {
                                    const suppressObject = { site: site, reason: this.suppressionReason};
                                    suppressedArray.push(suppressObject)
                                });
                            }

                        if (this.bulkUnsuppress.length > 0) {
                            suppressedArray = suppressedArray.filter((obj)=> !this.bulkUnsuppress.includes(obj.site));
                            
                            }

                        if (!isNaN(listingIndex)) {
                            // only update if index is a number
                            let listing = item.listing
                            
                            for (let i = 0; i < this.bulkEditSelected.length; i++) {
                                // if location, then look for other listings that have same "old" location
                                if (this.bulkEditSelected[i] === 'location') {
                                    let oldLocation = this.selected[k].listing.location;

                                    for (let m = 0; m < listing.length; m++) {
                                        if (listing[m].location === oldLocation) {
                                            listing[m].location = this.defaults[this.bulkEditSelected[i]];
                                        }
                                    }
                                } else {
                                    listing[listingIndex][this.bulkEditSelected[i]] = this.defaults[this.bulkEditSelected[i]];
                                }
                            }



                            if (this.bulkSuppress.length > 0 || this.bulkUnsuppress.length > 0 ) {
                                await this.updateItem(this.selected[k].itemId, { listing: listing, suppressed: suppressedArray });
                            } else {
                                await this.updateItem(this.selected[k].itemId, { listing: listing });
                            }

                            for (let n = 0; n < this.bulkEditItems.length; n++) {
                                if (this.bulkEditItems[n].itemId === this.selected[k].itemId) {
                                    this.bulkEditItems[n].status = 'success';
                                }                            
                            }
                        }
                    } catch (err) {
                            for (let n = 0; n < this.bulkEditItems.length; n++) {
                                if (this.bulkEditItems[n].itemId === this.selected[k].itemId) {
                                    this.bulkEditItems[n].status = 'error';
                                    
                                    if (err.message) {
                                        this.bulkEditItems[n].msg = err.message;
                                    }
                                }
                            }
                    }
                }

                // this.isBulkEditing = false;
            },
            cancelBulkEdit() {
                this.bulkEditSelected = [];
                this.bulkSuppress = [];
                this.bulkUnsuppress = [];
                this.suppressionReason = null;
                this.$bvModal.hide('bulkEditModal');
            },
            findListingIndex(item, listingId) {
                for (let i = 0; i < item.listing.length; i++) {
                    if (item.listing[i]._id === listingId) {
                        return i;
                    }
                }
            },
            researchSiteDisabled(site) {
                return this.defaults.researchSites.length === 1 && this.defaults.researchSites[0] === site;
            },
            fetchDefaults() {
                let defaultLocation = localStorage.getItem('inventoryLocation');

                if (defaultLocation) {
                    this.defaults.location = defaultLocation;
                }

                let defaultSource = localStorage.getItem('inventorySource');

                if (defaultSource) {
                    this.defaults.source = defaultSource;
                }

                let defaultHype = localStorage.getItem('inventoryHype');

                if (defaultHype) {
                    this.defaults.hype = defaultHype;
                }

                let defaultOffsite = localStorage.getItem('inventoryOffsite');

                if (defaultOffsite) {
                    this.defaults.offsite = defaultOffsite;
                }

                let defaultSearchSites = localStorage.getItem('researchSites');

                if (defaultSearchSites) {
                    this.defaults.researchSites = defaultSearchSites.split(',');
                }
            },
            selectAll() {
                this.$emit('selectAll');
            },
            clearSelected() {
                this.$emit('clearSelected');
            },
            print() {
                this.$emit('printSelected');
            },
            addItem() {
                this.$emit('addItem');
            },
            createTemplate() {
                this.$emit('createTemplate');
            },
        },
        computed: {
            countText() {
                if (!this.rowCount) {
                    return `0 items`;
                }

                if (parseInt(this.rowCount) === 1) {
                    return `${this.rowCount} item`;
                }

                return `${this.rowCount} items`;
            }
        },
        watch: {
            defaults: {
                deep: true,
                handler() {
                    localStorage.setItem('inventorySource', this.defaults.source);
                    localStorage.setItem('inventoryLocation', this.defaults.location);
                    localStorage.setItem('inventoryOffsite', this.defaults.offsite);
                    localStorage.setItem('researchSites', this.defaults.researchSites);
                    localStorage.setItem('inventoryHype', this.defaults.hype);
                }
            },
            settings: {
                deep: true,
                handler() {
                    this.$emit('updateSettings', this.settings);
                }
            }
        }
    }
</script>

<style scoped>

</style>